import React from "react";
import { Box, Typography } from "@mui/material";
import AdminPushSetup from "../Notifications/AdminPushSetup";

const Settings = () => {
  return (
    <Box sx={{ width: "100%", maxWidth: 900, mx: "auto", px: { xs: 1.25, sm: 2 }, pb: 5 }}>
      <Typography sx={{ color: "primary.main", fontSize: "0.65rem", fontWeight: 900, letterSpacing: 1 }}>
        PREFERÊNCIAS DO ADMIN
      </Typography>
      <Typography component="h1" sx={{ mt: 0.3, mb: 0.35, fontSize: { xs: "1.4rem", sm: "1.8rem" }, fontWeight: 850 }}>
        Configurações
      </Typography>
      <Typography sx={{ mb: 2, color: "text.secondary", fontSize: { xs: "0.75rem", sm: "0.82rem" } }}>
        Escolha como este dispositivo deve avisar você.
      </Typography>

      <AdminPushSetup />
    </Box>
  );
};

export default Settings;
